import { RangeCalendarGrid_default } from "../RangeCalendar/RangeCalendarGrid.js";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/DateRangePicker/DateRangePickerGrid.vue?vue&type=script&setup=true&lang.ts
var DateRangePickerGrid_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "DateRangePickerGrid",
	props: {
		asChild: {
			type: Boolean,
			required: false
		},
		as: {
			type: null,
			required: false
		}
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(RangeCalendarGrid_default), normalizeProps(guardReactiveProps(props)), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/DateRangePicker/DateRangePickerGrid.vue
var DateRangePickerGrid_default = DateRangePickerGrid_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { DateRangePickerGrid_default };
//# sourceMappingURL=DateRangePickerGrid.js.map